import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

import { Button } from '@/components/button'
import { ScrollArea } from '@/components/scroll-area'
import { Skeleton } from '@/components/skeleton'

interface GuardianCardProps extends HTMLAttributes<HTMLDivElement> {
  url_obj: string
  descricao: string
  url_site: string
  nome: string
}

export function GuardianCard({
  className,
  descricao,
  nome,
  url_obj: image,
  url_site: url,
}: GuardianCardProps) {
  return (
    <div
      className={twMerge(
        'group relative h-120 w-[90vw] overflow-hidden rounded-2xl bg-white py-2 shadow-lg lg:block lg:h-60 lg:w-92 lg:py-0 2xl:w-100',
        className,
      )}
    >
      {image ? (
        <img
          className="m-auto h-1/2 w-full object-contain px-4 lg:absolute lg:inset-0 lg:h-full lg:transform lg:transition-transform lg:duration-500 lg:group-hover:opacity-0"
          src={image}
          alt=""
        />
      ) : (
        <div className="h-1/2 lg:h-auto">
          <Skeleton className="m-auto flex size-40 flex-1 items-center justify-center rounded-full lg:absolute lg:inset-0 lg:size-40">
            <p className="font-bold text-monochromatic-400">Imagem</p>
          </Skeleton>
        </div>
      )}

      <div className="m-auto w-full space-y-5 bg-white p-8 lg:absolute lg:inset-0 lg:h-full lg:opacity-0 lg:transition-opacity lg:duration-500 lg:group-hover:opacity-100">
        <ScrollArea className="h-32 text-bios-secondary">
          <strong className="uppercase">{nome} - </strong>
          <span className="text-bios-secondary">{descricao}</span>
        </ScrollArea>

        <div className="flex justify-center">
          <Button asChild>
            <a target="_blank" href={url} rel="noreferrer">
              Saiba mais
            </a>
          </Button>
        </div>
      </div>
    </div>
  )
}
